import { writable } from 'svelte/store';
import type { Alert } from './alert.type';
import { ALERT_FADE_IN } from './alert.config';

export const alerts = writable<Array<Alert>>([]);

export const handleAlert = async (alert: Alert): Promise<void> => {
	// Check if alert.text is a Promise and resolve it
	if (
		alert.text &&
		typeof alert.text === 'object' &&
		typeof (alert.text as any).then === 'function'
	) {
		try {
			alert.text = await alert.text;
		} catch (e) {
			console.error('Error resolving alert text Promise:', e);
			alert.text = 'An error occurred.';
		}
	}

	// Additional check: if text is still an object, log for debugging but use safe fallback
	if (alert.text && typeof alert.text === 'object') {
		console.warn('Alert text is an object, using safe fallback:', alert.text);
		alert.text = 'An error occurred.'; // Safe fallback instead of exposing object content
	}

	alerts.update((alerts) => alerts.concat([alert]));
	clearAlertTimeout();
};

export const clearAlert = () => alerts.update((alerts) => alerts.slice(1));
export const clearAlertTimeout = () => setTimeout(clearAlert, ALERT_FADE_IN);
